import { render, staticRenderFns } from "./RemotePaymentLink.vue?vue&type=template&id=04f8c766&"
import script from "./RemotePaymentLink.vue?vue&type=script&lang=js&"
export * from "./RemotePaymentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
